
import React, { useEffect, useRef, useState } from "react";
import ViewIndividualMembersFormData, { GridConfig, tableData } from "./data/ViewIndividualMembersForm.data";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { useGetIndividualMemberListMutation } from "../../app/services/Individual/ViewIndividualMemberApi";
import formatDate from "../../lib/formatDate";
import { encryptAESID } from "../../utils/Encryption";
import { useNavigate } from "react-router-dom";
import SwalAlert from "../../services/swalService/SwalService";
import { useLazyDeleteViewMemberQuery } from "../../app/services/Common/CommonApi";
import ToastService from "../../services/toastService/ToastService";
import { getAuthProps } from "../../lib/authenticationLibrary";
import { AispWebUrl } from "../../utils/AppSetting";

const ViewIndividualMembersForm = (props) => {
  const navigate = useNavigate()
  const viewIndividualMembersFormRef = useRef();
  const molGridRef = useRef();
  const { confirm, error, success, confirmDelete } = SwalAlert();
  const [searchFormData, setSearchForm] = useState(ViewIndividualMembersFormData);
  const [indicidualMemberList, setIndicidualMemberList] = useState(null);
  const [loginAdminId, setLoginAdminId] = useState("");
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 10,
    endPage: 100,
    SearchText: "",
    endDate: "",
    totalCount: 0,
    statusId: null,
    membershipTypeId: null
  });

  useEffect(() => {
    let loginData = getAuthProps();
    setLoginAdminId(loginData.adminUserId);
    getMemberList()
  }, [])

  const [memberList,
    { isSuccess: isSuccess,
      isLoading: isLoading,
      data: memberListResponse },
  ] = useGetIndividualMemberListMutation();

  const [deleteRecord, {
    data: deleteResponse,
    isSuccess: isDeleteSuccess,
    isLoading: isDeleteLoading,
  }] = useLazyDeleteViewMemberQuery()

  useEffect(() => {
    if (!isLoading && isSuccess && memberListResponse) {
      let tempList = memberListResponse.itemList.map((obj) => {
        return { ...obj, subscriptionEndDate: formatDate(obj?.subscriptionEndDate, "DD/MM/YYYY") }
      })
      setPaginationRequest({ ...paginationRequest, totalCount: memberListResponse.totalCount })
      setIndicidualMemberList(tempList)
    }
  }, [isLoading, isSuccess, memberListResponse]);

  useEffect(() => {
    if (!isDeleteLoading && isDeleteSuccess && deleteResponse) {
      ToastService.success("Delete Item successfully");
      memberList(paginationRequest)
    }
  }, [isDeleteLoading, isDeleteSuccess, deleteResponse])

  const getMemberList = (rData) => {
    const request = {
      ...paginationRequest, ...rData
    }
    memberList(request)
  }
  const handlePageChange = (newPage) => {
    setPaginationRequest(previous => {
      const tempPagination = { ...previous, pageNo: newPage.pageNumber, pageSize: newPage.pageSize }
      getMemberList(tempPagination)
      return tempPagination
    })
  }
  const handleSearch = () => {
    if (viewIndividualMembersFormRef) {
      let formData = viewIndividualMembersFormRef.current.getFormData()
      let data = {
        searchText: formData.name,
        statusId: formData.statusId?.value ? formData.statusId?.value : formData.statusId,
        endDate: formData.subscriptionEndDate,
        membershipTypeId: formData.membershipTypeId?.value ? formData.membershipTypeId?.value : formData.membershipTypeId,
        pageNo: 1
      }
      setPaginationRequest({ ...paginationRequest, ...data })
      getMemberList(data);
    }
  }

  const handleCustomActionClick = (rowData, buttonName) => {
    if (buttonName === "View") {
      navigate(`/editIndividualMembers/${encryptAESID(rowData.individualMemberId)}`)
    }
    else {
      handleTableDelete(rowData?.individualMemberId)
    }
  }

  const handleTableDelete = (memberID) => {
    const request = {
      id: memberID,
      isCorporateMember: false,
      isAcademicMember: false,
      deletedBy: loginAdminId,
    }
    confirmDelete("Are you sure?", "Type 'delete' to confirm", "Delete", "Cancel")
      .then((confirmed) => {
        if (confirmed) {
          deleteRecord(request);
        }
      });

  }
  const actionHandler = {
    "CUSTOM_ACTION_CLICK": handleCustomActionClick
  }
  const handleCreateNewSignup = () => {
    let loginData = getAuthProps();
    window.open(`${AispWebUrl}/individual/${encryptAESID(loginData?.adminUserId)}`);
  }

  return (
    <div className="form-field-sec">
      <div className="row align-items-end">
        <div className="col-10">
          <div className="row gx-5">
            <FormCreator
              ref={viewIndividualMembersFormRef}
              {...searchFormData}
            ></FormCreator>
          </div>
        </div>

        <div className="col-2 d-flex justify-content-end">
          <div className="two-button-fixes">
            <div className="d-none">
              <Buttons
                buttonText="Clear"
                buttonTypeClassName="theme-btn"
              />
            </div>
            <div className="mb-3">
              <Buttons
                buttonText="Search"
                buttonTypeClassName="theme-btn"
                onClick={handleSearch}
              />
            </div>
            <div className="mb-6">
              <Buttons
                buttonText="Create New"
                buttonTypeClassName="theme-btn"
                onClick={handleCreateNewSignup}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row align-items-center">
        <div className="col-span-12">
          <div className="card-section mt-4">
            <h1 className="account-info-title">
              Total :{paginationRequest.totalCount}
            </h1>
            <MolGrid
              ref={molGridRef}
              configuration={GridConfig}
              dataSource={indicidualMemberList}
              allowPagination={true}
              isLoading={isLoading}
              pagination={paginationRequest}
              onPageChange={handlePageChange}
              onActionChange={actionHandler}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewIndividualMembersForm;
